import React, { useEffect, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import { useDispatch, useSelector } from 'react-redux';
import pin from '../../assets/images/pin.png';
import pinGreen from '../../assets/images/pin_green.png';
import pinRed from '../../assets/images/pin_red.png';
import pinAmber from '../../assets/images/pin_amber.png';
import { Icon } from 'leaflet';
import Datagrid from '../ui/Datagrid';
import columns from './table_config';
import { Grid } from '@mui/material';
import { renderCell } from '../ui/Datagrid/table_config';
import { MAP_TYPES, REDUX_ACTIONS } from '../../shared/config/constants';
import PropTypes from 'prop-types';
import { gridFilteredSortedRowEntriesSelector, useGridApiRef } from '@mui/x-data-grid-pro';
import MapComponent from '../map';
import { fetchAssetsMap } from '../../store/actions/assetMap';

const pins = {
  default: pin,
  green: pinGreen,
  red: pinRed,
  amber: pinAmber,
};

const AssetsMap = () => {
  const dispatch = useDispatch();
  const assetsMap = useSelector((state) => state.assetsMap);
  const [rowId, setRowId] = useState(null);
  const [gmapRowId, setGmapRowId] = useState(null);
  const mapType = process.env.REACT_APP_JOBS_PAGE_MAP;
  const apiRef = useGridApiRef();
  const [jobMarker, setJobMarker] = useState([]);
  const [initialMarker, setInitialMarker] = useState(true);
  const [iconPinSize, setIconPinSize] = useState([15, 25]);

  useEffect(() => {
    if (!assetsMap?.loading) {
      dispatch(fetchAssetsMap());
    }
  }, []);

  useEffect(() => {
    if ((assetsMap?.marker_data.length && initialMarker)) {
      setJobMarker(assetsMap?.marker_data);
      setInitialMarker(false);
    }
    if (!assetsMap?.markerFilter && !initialMarker) {
      setJobMarker(assetsMap?.marker_data);
    }
  }, [assetsMap?.marker_data]);

  const getGoogleMapPin = () => {
    const pinIcon = pins.default;
    return {
      url: pinIcon,
      // eslint-disable-next-line no-undef
      scaledSize: new google.maps.Size(iconPinSize[0], iconPinSize[1]),
      // eslint-disable-next-line no-undef
      size: new google.maps.Size(iconPinSize[0] + 10, iconPinSize[1] + 10)
    };
  };

  const getMapPin = () => {
    const pinIcon = pins.default;

    return (
      pinIcon &&
      new Icon({
        iconUrl: pinIcon,
        iconSize: iconPinSize,
        popupAnchor: [0, -5],
      })
    );
  };

  const [columnsList] = useState(columns(renderCell));
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

  const handleVisibiltyModel = (newModel) => {
    setColumnVisibilityModel(newModel);
  };

  return (
    <Grid container justifyContent="center">
      <MapComponent
        mapType={mapType}
        mapData={jobMarker}
        markerData={jobMarker}
        data={assetsMap}
        latitudeField={'Latitude'}
        longitudeField={'Longitude'}
        popUpLabel={['SN', 'Well', 'Rig']}
        getGoogleMapPin={getGoogleMapPin}
        getMapPin={getMapPin}
        gmapRowId={gmapRowId}
        rowId={rowId}
        setIconPinSize={setIconPinSize}
      />
      <Grid item xs={12}>
        <Datagrid
          apiRef={apiRef}
          data={assetsMap?.data || []}
          columns={columnsList}
          loading={assetsMap?.loading}
          onRowClick={({ row: job }) => {
            if (mapType === MAP_TYPES.GOOGLEMAP) {
              setGmapRowId(job._id);
            } else {
              setRowId(job);
            }
          }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) => {
            handleVisibiltyModel(newModel);
          }}
          getRowId={(row) => row?.grid_id}
          sx={{
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold !important',
            },
            '.MuiDataGrid-cell': {
              fontSize: 'medium',
              fontWeight: 'bold !important'
            },
          }}
          onFilterModelChange={() => {
            setTimeout(() => {
              const filterData = gridFilteredSortedRowEntriesSelector(apiRef).map((item) => item.model);
              if (filterData) {
                setJobMarker(filterData);
                dispatch({
                  type: REDUX_ACTIONS.JOBS_MARKER_FILTER,
                  payload: {
                    data: filterData,
                  }
                });
              }
            }, 300);
          }}
          editMode="cell"
          toolbar={{
            options: {
              columns: true,
              filters: true,
              export: false,
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

AssetsMap.propTypes = {
  row: PropTypes.object,
};

export default AssetsMap;
